import customAxios from "../../customAxios";
import {DELETE_SCHOOL} from "../../routes";

const deleteSchool = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_SCHOOL + `/${userId}`)).data;
  } catch (error: any) {
    console.log({DELETE_SCHOOL: error});
    return false;
  }
};

export default deleteSchool;
